import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgForbiddenSignLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18.8939 5.10603C15.0868 1.29799 8.91296 1.29799 5.10583 5.10603C1.29773 8.91304 1.29773 15.087 5.10583 18.894C8.91296 22.702 15.0868 22.702 18.8939 18.894C22.702 15.087 22.702 8.91304 18.8939 5.10603ZM18.3402 6.71986C21.0453 9.96126 20.8763 14.7907 17.8339 17.834C14.7904 20.8764 9.9613 21.0451 6.7196 18.3402L18.3402 6.71986ZM5.65955 17.2802C2.95447 14.0387 3.12341 9.2093 6.16589 6.16603C9.20935 3.12367 14.0385 2.95491 17.2802 5.65987L5.65955 17.2802Z",
		fill: "currentColor"
	})
});
export default SvgForbiddenSignLine;
